import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";

function LegalDialog({ testid, title, paragraphs }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button data-testid={testid} className="hover:text-white transition-colors">{title}</button>
      </DialogTrigger>
      <DialogContent className="rounded-none">
        <DialogHeader>
          <DialogTitle className="font-heading">{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {paragraphs.map((p, i) => (
            <p key={i} className="text-sm text-[#5A6B7C] leading-relaxed">{p}</p>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default function Footer({ t }) {
  return (
    <footer className="bg-[#0B1B3D] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10 pb-12 border-b border-white/15">
          <div>
            <Logo light />
            <p className="text-sm text-white/60 mt-6 max-w-sm" data-testid="footer-tagline">
              {t.footer.tagline}
            </p>
          </div>
          <div className="flex items-center gap-8 text-sm text-white/60">
            <LegalDialog testid="footer-legal-link" title={t.footer.links.legal} paragraphs={t.footer.legalContent} />
            <LegalDialog testid="footer-privacy-link" title={t.footer.links.privacy} paragraphs={t.footer.privacyContent} />
            <Link to="/#contact" data-testid="footer-contact-link" className="hover:text-white transition-colors">
              {t.footer.links.contact}
            </Link>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <span data-testid="footer-legal">{t.footer.legal}</span>
          <span>© {new Date().getFullYear()} MKN Projects</span>
        </div>
      </div>
    </footer>
  );
}
